import { css } from '@emotion/css'

export const OrContainer = css`
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`

export const OrSeperator = css`
  width: 120px;
  height: 0.06rem;
`
